import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader.component';
import { BrowserModule } from '@angular/platform-browser';
@NgModule({
  declarations: [LoaderComponent],
  imports: [
    CommonModule,
    BrowserModule
  ],
  exports: [LoaderComponent],
})
export class LoaderModule { }
